import { ElementRef } from '@angular/core';
import { PaginationStrategy } from './pagination-strategy.service';

export class FitToContainerPaginationStrategy extends PaginationStrategy {
    private _pageCount = 0;
    private _itemsPerPage = 0;

    private _container: ElementRef;
    private _itemHeight: number = 1;
    private _gap: number = 0;

    public init(container: ElementRef, itemHeight: number, gap: number) {
        this._container = container;
        this._itemHeight = itemHeight;
        this._gap = gap;
    }

    recalculate(numberOfItems: number) {
        this._itemsPerPage = this.calculatePageSize();
        this._pageCount = this.calculatePageCount(numberOfItems);
    }

    getPageCount(): number {
        return this._pageCount;
    }

    getItemsPerPage(): number {
        return this._itemsPerPage;
    }

    private calculatePageSize() {
        const containerHeight = this.getMainContentHeight();
        const itemHeight = this._itemHeight;
        const gap = this._gap;

        let fitElementCount = Math.floor(containerHeight / (itemHeight + gap));

        if (fitElementCount == 0) {
            fitElementCount = Math.floor(containerHeight / itemHeight);
        } else if (fitElementCount > 1) {
            //Remove the gap from the last element and check if one more element
            // can fit in the container.

            //Calculate the height of the content without the gap of the last element
            let filledHeight = fitElementCount * (itemHeight + gap) - gap;

            //Append one more element if it fits
            if (filledHeight + containerHeight <= containerHeight) {
                fitElementCount++;
            }
        }

        return Math.max(fitElementCount, 1);
    }

    private getMainContentHeight() {
        return this._container.nativeElement.clientHeight;
    }

    private calculatePageCount(numberOfElements: number) {
        return Math.ceil(numberOfElements / this._itemsPerPage);
    }
}
